
  function ChatWindow(aEnrolleeId){
    this.EnrolleId = aEnrolleeId;
    this.schema = gUserDetails.CurrentSchema.SchemaName;
    this.Id = aEnrolleeId;
    this.agent = gUserDetails;
    this.enrolleeTimeZone = getEnrolleeTimeZone(this.EnrolleId);
    this.Enrollee = getDataItem(this.EnrolleId,"Enrollees");
    this.AgentId = gUserDetails.UserId;
    this.orderList = [];
    this.messages =[];
    this.audio = new Audio('Scripts/Interface/chat.mp3');
    this.pagination = {
      currentPage: 1,
      pageSize: 19,
      startPage: 1,
      hasAfter:true,
      startIndex: 0,
    };
    
  }
  ChatWindow.prototype.connect = function(){
    this.socketChat = new Socket(gServerList['API'].ChannelApi);
    this.loading = true;
    this.channelName = 'enl_:'+this.schema + '_' + this.EnrolleId;
    this.socketChat.connect();
    var json = {
      token: this.token 
    };
    this.channelChat = this.socketChat.channel( this.channelName, json);
    // join the channel and listen for admittance
    this.channelChat
      .join()
      .receive('ignore', function(envelope){
        //'Access denied.'
      })
      .receive('ok', function (res) {
        //channel connected
        
        this.loading = false;
      })
      .receive('timeout', function(e){
        //timeout
        this.loading = false;
      })
      .receive('error', function(e) {
        // 'Socket no opened, error
        this.loading = false;
      });
    this.channelChat.on('phx_reply', function(response) {
    });
    var onMessage = function(obj) {
      var itsMe = obj.sourceId === this.AgentId ;
      this.renderMessage(obj);
      if(itsMe){
        this.audio.play();
      }
      this.scrollTop();

    };
    this.channelChat.on('msgme_'+ this.schema+'_'+this.EnrolleId, onMessage.bind(this));
    // var onUpdateMe = function(obj){
    //   
    // }
    // this.channelChat.on('updateme_'+this.schema+'_'+this.EnrolleId, onUpdateMe.bind(this));
  };
  ChatWindow.prototype.scrollBottom = function(){
    document.getElementById('uChatMessagesContainer'+this.Id).scrollBottom = document.getElementById('uChatMessagesContainer'+this.Id).scrollHeight;
  }
  ChatWindow.prototype.scrollTop = function(){
    document.getElementById('uChatMessagesContainer'+this.Id).scrollTop = document.getElementById('uChatMessagesContainer'+this.Id).scrollHeight;
  }
  ChatWindow.prototype.disconnect = function(){
    this.socketChat.disconnect();
  };
  ChatWindow.prototype.open = function(){
    var aEnrollee = getDataItem(this.EnrolleId,'Enrollees');
    var html =[
      '<div class="chat" id="uChat',this.Id,'" style="display:flex;">',
        '<div class="chat__header " id="uChatTitle" style="height: 25px;line-height: 25px;color: white;padding: 5px;background:#3a79b8;">',
        '<div class="chat__header--title ">',aEnrollee.FullName,'</div>',
        '<div class="chat__header--icon_close Clickable" id="uChat',this.Id,'Close"></div>',
        '</div>',
        '<div class="chat__messages" id="uChatMessagesContainer',this.Id,'" >',
          '<div class="chat__messages--top" ><button id="uChatMessagesReload',this.Id,'" >Load more</button></div>',
          '<ul id="uChatMessages',this.Id,'">',
          '<img src="Images/ProgressBar.gif" alt="Loading..." />',
          '</ul>',
        '</div>',
        '<div id="chatMessage',this.Id,'" class="chat__controls" >',
           ' <textarea id="uChatMessage',this.Id,'"></textarea>',
            '<button type="button" id="uChatSend',this.Id,'">Send</button>',
        '</div>',
      '</div>'
    ].join('');
    
      var doc = document.createElement('div');
    doc.id = "uOffenderChatId"+this.Id;
    doc.innerHTML = html;
    var element = document.getElementById('uOffenderChatId'+this.Id);
    //Add listeners
    document.getElementById('uMasterBody').appendChild(doc); 
    document.getElementById('uChat'+this.Id+'Close').addEventListener("click",this.close.bind(this));
    document.getElementById('uChatMessage'+this.Id).addEventListener("keyup",this.onKeyUp.bind(this));
    document.getElementById('uChatSend'+this.Id).addEventListener("click",this.sendMessage.bind(this));
    document.getElementById('uChatMessagesReload'+this.Id).addEventListener("click",this.loadMoreMessages.bind(this));

    function cb(token){
      this.token = token;
      this.connect();
      this.getMessages(this.EnrolleId);
    }
    veritracks.security.controller.getJWT(cb.bind(this));
  };
  ChatWindow.prototype.loadMoreMessages = function(){
    if(!this.pagination.hasAfter){
      document.getElementById('uChatMessagesReload'+this.Id).style="display:none";
      return;
    }
    this.pagination.currentPage = this.pagination.currentPage + 1;
    this.getMessages(this.EnrolleId);

  }
  ChatWindow.prototype.sendMessage =  function (){
    var text = document.getElementById('uChatMessage'+this.Id).value;
    if (!text.replace(/\s/g, '').length) {
      
      return;
    }
    var msg = {
      destinationId: this.EnrolleId,
      sourceId: this.AgentId,
      agentName:this.agent.FullName,
      sourceApplication: 'Veritracks Mobile',
      destinationApplication: 'Enrollink',
      notificationText: text,
      notificationType: 1,
      enrolleeTimeZone: this.enrolleeTimeZone.TimeZoneName,
      notificationDate: new Date(),
      receivedDate: null,
      token: this.token,
    };
    /**
     * how to send to target
     **/
    var OnReceiveMessage = function(obj){
      
    };
    this.channelChat
      .push('msgme_'+this.schema+'_'+this.EnrolleId, msg)
      .receive('ok',OnReceiveMessage.bind(this))
      .receive('error', function(reasons){
      });
    document.getElementById('uChatMessage'+this.Id).value ='';
  };
  ChatWindow.prototype.readUnSeenMessages = function(messages){
    var UnSeenMessagesFilter = function (msg){
      // var itsMe = msg.sourceId === this.AgentId ;
      // var itsEnrollee = msg.sourceId === this.EnrolleId;
      return (msg.receivedDate === null && parseInt(msg.destinationId) === this.AgentId);
    };
    var reducedList = messages.filter(UnSeenMessagesFilter.bind(this));
    if (reducedList.length >= 1) {
      for (var i=0;i<reducedList.length; i++) {
        this.updateMeMessage(reducedList[i]);
      }
    }
  }
  ChatWindow.prototype.updateMeMessage = function(msj){
    var payload= {
      id: parseInt(msj.id),
      sourceId: msj.sourceId,
      token: this.token,
    };
    
    this.channelChat
      .push('updateme_'+this.schema+'_'+this.EnrolleId, payload)
      .receive('ok',function(obj){
        
      })
      .receive('error', function(reasons){
        
      });
  }
  ChatWindow.prototype.onKeyUp = function(event){
    if (event.keyCode === 13) {
      // Cancel the default action, if needed
      event.preventDefault();
      // Trigger the button element with a click
      document.getElementById('uChatSend'+this.Id).click();
    }
  };

  ChatWindow.prototype.getMessages = function (
    destinationId
  ) {
    var url = 'message/-1/' +destinationId+'/'+ this.pagination.currentPage;
    var onSuccess = function (outParams,messageList){
      this.pagination.hasAfter = messageList.length >= this.pagination.pageSize ? true : false;
      var list = this.messages.concat(messageList);
      this.messages = list.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.notificationDate) - new Date(a.notificationDate);
      });
      this.readUnSeenMessages(this.messages);
      this.orderList = this.mapList(this.messages.reverse());
      document.getElementById('uChatMessages'+this.Id).innerHTML =''; // clear messages
      for(var date in this.orderList){
        this.renderDate(date);
       for(var k = 0; k < this.orderList[date].length; k++ ){
          if(this.orderList[date][k]){
            var b = this.orderList[date][k-1];
         var isPrevMessageSameSource = typeof b !== "undefined" && this.orderList[date][k].sourceId === b.sourceId;
            this.renderMessage(this.orderList[date][k],isPrevMessageSameSource);
          }
       }
      }

      if(this.pagination.currentPage == 1){
        this.scrollTop();
      }
    };
    var aOnFailure = function (outParams,response){
    };
    if (!isNullOrUndefined(this.token)) {
      callAjaxAPI('GET',
      this.token,
      url,
      null,
        onSuccess.bind(this), aOnFailure.bind(this),{}, false);
    }
  };
  
  /**
   * This function closes the chat and destroys any binding.
   * @name close
   */
  ChatWindow.prototype.close = function (){
    var element = document.getElementById('uOffenderChatId'+this.Id);
    if(element){
      document.getElementById('uChatSend'+this.Id).removeEventListener("click",this.sendMessage.bind(this));
      document.getElementById('uChatMessage'+this.Id).removeEventListener("keyup",this.onKeyUp.bind(this));
      document.getElementById('uChat'+this.Id+'Close').addEventListener("click",this.close.bind(this));
      element.parentNode.removeChild(element);
      this.disconnect();
      this.audio.remove();
    }    
  };
  ChatWindow.prototype.mapList = function(messageList){
    var order ={};
    if(messageList.length > 0){
      for(var k = 0; k < messageList.length; k++ ){
        var date = moment(messageList[k].notificationDate).format('D-MMM-YYYY');
        if (!order[date]) order[date] = [];
        order[date].push(messageList[k]);
      }
    }
    return order;
  }
  /**
   * This function appends a message element into the chat messages by passing the message object and passing the flag if agent its sending message 
   * @name renderMessage
   * @param  {} message
   * @param  {} isAgent
   */
  ChatWindow.prototype.renderMessage = function (obj,isPrevMessageSameSource){
    var doc = document.createElement('li');
    doc.id = "u"+this.Id+"__" + Date.now(); 
    var itsMe = obj.sourceId === this.AgentId ;
    var itsEnrollee = obj.sourceId === this.EnrolleId;
    var className ='';
    className += itsMe ?' me':' other';
    className += itsEnrollee ?' enrollee':' agent';
    doc.className = className;
    var name = obj.agentName? obj.agentName:'';
    if(itsEnrollee){
      name = this.Enrollee.FullName;
    }else {
      name = obj.agentName? 'Agent '+ obj.agentName:' ';
    }
    if(isPrevMessageSameSource){
      name = '';
    }
    var seen = itsMe && obj.receivedDate !== null ? '<img class="seen__at" src="Images/check-symbol.svg"  title=" Seen by '+this.Enrollee.FullName +' on '+moment(obj.receivedDate).format('MMMM Do YYYY, h:mm:ss a')+'" alt="" />':'';
    doc.innerHTML = [
      '<div class="message">',
        '<div class="name">',name,'</div>',
        '<div class="message__text">', 
          obj.notificationText,seen,
          '<span class="time ">',moment(obj.notificationDate).format('LT'),'</span>',
        '</div>',
        
      '</div>'
    ].join('');
    if(obj.notificationText){
      document.getElementById('uChatMessages'+this.Id).appendChild(doc);
    }
  };

  ChatWindow.prototype.renderDate = function(date){
    var doc = document.createElement('li');
    doc.id = "u"+this.Id+"__" + Date.now(); 
    doc.className  = "date";
    doc.innerHTML = moment(date).format('MMM Do YYYY ');
    document.getElementById('uChatMessages'+this.Id).appendChild(doc);
    document.getElementById('uChatMessagesContainer'+this.Id).scrollTop = document.getElementById('uChatMessagesContainer'+this.Id).scrollHeight;

  }
  if(!mEnrolleeActiveChats){
    mEnrolleeActiveChats = null;
  }
  function uEnrolleesMobileMessage_CloseAll(array){
    for(var i=0;i<array.length;i++){
      array[i].close();
      array.splice(i,1);
    }
  }
  function uEnrolleesMobileMessage_OnClick(){
    // add validation if contains enrollink 
    if(mEnrolleesData.OffenderCurrentEMAFlag){
      // open chat only if the offender has EMAFlag enabled.
      var id = mEnrolleesData.OffenderCurrentId;
      
      if(mEnrolleeActiveChats && mEnrolleeActiveChats.length > 0){
        uEnrolleesMobileMessage_CloseAll(mEnrolleeActiveChats);
        // mEnrolleeActiveChat.close();
        // mEnrolleeActiveChat = null;
      }
      var chat = new ChatWindow(id);
      mEnrolleeActiveChats.push(chat);
      mEnrolleeActiveChats[0].open();
      // mEnrolleeActiveChat.open();
    }
  }
